import { render, staticRenderFns } from "./SensorDeviceCompoent.vue?vue&type=template&id=22e1c5ee&"
import script from "./SensorDeviceCompoent.vue?vue&type=script&lang=ts&"
export * from "./SensorDeviceCompoent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports